import { defineComponent } from "vue";
import SectionRibExtend from '@/extend/sections/SectionRibExtend.vue';
import Section from '@/framework/base/classes/Section';
import { Sections } from '@/generated/classes/AppSchema';
import PaymentMeans, { PaymentMeansTypes } from '@/generated/classes/PaymentMeans';
import PaymentMeansSummary from '@/generated/controls/paymentMeans/PaymentMeansSummary.vue';
import { storeRib, storeEtablissement } from '@/generated/stores';
import Item from '@/framework/base/classes/Item';
import Rib from '@/extend/classes/Rib';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import Owner from '@/extend/classes/Owner';

export default defineComponent({
  extends: PaymentMeansSummary,
  name: 'PaymentMeansSummaryExtend',
  components: {},
  computed: {
    items (): Item[] {
      const items: Item[] = [];
      const paymentMeanss = this.getItems(this.listItems, this.sectionName);
      paymentMeanss.forEach(paymentMeans => {
        if (paymentMeans && paymentMeans.id > 0) {
          items.push(new Item(paymentMeans.id, this.getDisplay(paymentMeans)));
        }
      })
      return items;
    },
    section (): Section {
      const section = new Section();
      if (this.selectedPaymentMeans && this.selectedPaymentMeans.type == PaymentMeansTypes.RIB) {
        if (this.sectionName == Sections.PRELEV_MEANS) {
          section.propType = 'defaultPaymentMeansType';
          section.propData = PaymentMeansTypes.RIB;
        }
        section.component = SectionRibExtend;
        const ribId = this.selectedPaymentMeans ? this.selectedPaymentMeans.typeId : 0;
        let rib = new Rib();
        if (ribId == 0) {
          rib = storeRib.createNewRib();
          if (this.owner.objType == ObjTypes.ETABLISSEMENT) {
            const etablissement = storeEtablissement.getEtablissement(this.owner.objId);
            rib.owner = new Owner();
            rib.owner.objType = ObjTypes.CLIENT;
            rib.owner.objId = etablissement.clientId;
          } else {
            rib.owner = this.owner;
          }
        } else {
          rib = storeRib.getRib(ribId);
        }

        section.data = rib;
        section.type = 'rib';
        section.owner = this.owner;
      }
      section.picto = 'SectionPaymentPicto';
      section.contextId = this.contextId;
      section.showButton = true;
      section.autoSave = false;
      section.sectionName = this.sectionName;

      return section;
    },
    canEdit (): boolean {
      return this.selectedPaymentMeans.type != PaymentMeansTypes.VIREMENT;
    }
  },
  methods: {
    setSelectedPaymentMeans(value: PaymentMeans) {
      this.selectedPaymentMeans = value;
      if (value.id > 0 && value.id == this.initValue && this.selectedPaymentMeansId == 0) {
        this.itemChanged(value.id);
      }
    },
    getDisplay (paymentMeans: PaymentMeans): string {
      return paymentMeans.label;
    },
    setSectionUpdated (paymentMeans: PaymentMeans) {
      if (paymentMeans.id <= 0) {
        return;
      }
      this.loadItems().then(() => {
        const type = this.listPaymentMeans.find(a => a.typeId == paymentMeans.id);
        if (type) {
          const item = this.items.find(a => a.key == type.id);
          if (item) {
            this.setUpdated(item);
          }
        }
      });
    },
    setUpdated (item: Item): void {
      const selected = this.listPaymentMeans.find(a => a.id == item.key);
      if (selected.ownerId == 0 && selected.type == PaymentMeansTypes.RIB)  {
        this.dialogOpen = true;
        this.selectedPaymentMeans = this.newPaymentMeans();
      }
      this.itemChanged(item.key);
      this.status.updated = this.initValue != item.key;
      this.status.error = false;
      this.statusUpdated(this.status);
    },
  },
});
